import type { ComponentProps } from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { tv } from "tailwind-variants";

import { focusRing } from "./interaction";

const radioGroupVariants = tv({
  slots: {
    root: "grid gap-3",
    item: [
      "peer aspect-square size-4.5 shrink-0 cursor-pointer rounded-full border border-line-strong bg-surface shadow-xs",
      "transition-colors hover:border-focus",
      focusRing,
      "disabled:cursor-not-allowed disabled:border-line disabled:bg-surface-muted",
      "data-[state=checked]:border-surface-inverted data-[state=checked]:disabled:border-line data-[state=checked]:disabled:bg-surface-muted",
    ],
    indicatorWrapper: "relative flex items-center justify-center",
    indicator: "absolute top-1/2 left-1/2 size-2.5 -translate-1/2 rounded-full bg-surface-inverted",
  },
});

const { indicator, indicatorWrapper, item, root } = radioGroupVariants();

const Root = ({ className, ...props }: ComponentProps<typeof RadioGroupPrimitive.Root>) => {
  return (
    <RadioGroupPrimitive.Root className={root({ className })} data-slot="radio-group" {...props} />
  );
};

const Indicator = ({
  className,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Indicator>) => {
  return (
    <RadioGroupPrimitive.Indicator
      className={indicatorWrapper({ className })}
      data-slot="radio-group-indicator"
      {...props}
    >
      <span className={indicator()} />
    </RadioGroupPrimitive.Indicator>
  );
};

const Item = ({ className, ...props }: ComponentProps<typeof RadioGroupPrimitive.Item>) => {
  return (
    <RadioGroupPrimitive.Item
      className={item({ className })}
      data-slot="radio-group-item"
      {...props}
    />
  );
};

export const RadioGroup = { Root, Item, Indicator };
